<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section v-if="step === 1" class="page-section portfolio" id="portfolio">
            <div class="container">
                <div class="row justify-content-center loa-form">
                        <FindAProvider v-on:providercode="updateParentProvider" /> 
                </div>
            </div>
        </section>    
       

        <section v-if="step === 2" class="page-section portfolio" id="portfolio">
            <div class="container cpt-10">
                <div class="row justify-content-center">
                    <div>
                        <p class="h2 page-title phil-doctor-title">Find a Doctor</p>
                    </div>
                </div>
                <!-- Portfolio Grid Items-->
                <div class="row justify-content-center">
                    <!-- Portfolio Item 1-->
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal1">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn mb-login-btn"> <router-link to="/by-name"> <img class="img-fluid" src="../assets/By-name (1).png" alt="..." /> </router-link> </a>
                            <p class="h3">By Name</p>
                        </div>
                    </div>
                    <!-- Portfolio Item 2-->
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn mb-login-btn"> <router-link to="/by-specialization"> <img class="img-fluid" src="../assets/by-specialization.png" alt="..." /> </router-link> </a>
                            <p class="h3">By Specialization</p>
                        </div>
                    </div>
                    
                </div>
            
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <router-link to="/member-page"><button class="btn btn-primary btn-lg" style="margin-top: 25px;">BACK</button></router-link>
                </div>
            </div>
        </div>
        </section>
</body>
</template>

<script>
import FindAProvider from '../components/FindAProvider.vue'
export default {
  name: 'PhilLogin',
  data() {
    return {
        step: 1
    }
  },
  props: {
    msg: String
  },
  created() {
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  },
  methods : {
    updateParentProvider(value_from_child) {
      
       if (value_from_child != 0) {
            this.step = 2
            localStorage.setItem('setProvider', value_from_child)
       }
    }
  },
  components: {
    FindAProvider
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
